module.exports = __webpack_public_path__ + "static/Gotham-ExtraLightItalic-c57d3607fffeb8647d1bdfd22d7008a0.woff2";